import Vue from 'vue' //引入Vue
import Router from 'vue-router' //引入vue-router
Vue.use(Router)

import appMain  from '../view/pages/appMain.vue'
//Vue全局使用Router
const originalPush = Router.prototype.push
Router.prototype.push =function push(location){
  return originalPush.call(this,location).catch(err =>err)
}
export default new Router({
  mode:"history",
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    return {
      x: 0,
      y: 0
    }
  },

  routes: [ //配置路由，这里是个数组
    { //每一个链接都是一个对象
      path: '/', //链接路径
      redirect: '/index',
      component: appMain,
      children:[

        {
          path: '/index',
          name: 'index',
          component: () => import('@/view/pages/index.vue'),
        },
        // {
        //   path: '/games',
        //   name: 'games',
        //   component: () => import('@/view/pages/games.vue'),
        // },
      
        
        
        // {
        //   path: '/serviceAgreement',
        //   name: 'serviceAgreement',
        //   component: () => import('@/view/info/serviceAgreement.vue'),
        // },
        {
          path: '/privacy-policy',
          name: 'privacy-policy',
          component: () => import('@/view/info/privacy-policy.vue'),
          meta:{
            header_bg:true,//header添加背景颜色
          }
        },
        {
          path: '/about-us',
          name: 'about-us',
          component: () => import('@/view/info/about-us.vue'),
        },
       
        {
          path: '/terms',
          name: 'terms',
          component: () => import('@/view/info/terms.vue'),
          meta:{
            header_bg:true,//header添加背景颜色
          }
        },
        {
          path: '/contact-us',
          name: 'contact-us',
          component: () => import('@/view/info/contact-us.vue'),
        },
        // {
        //   path: '/join',
        //   name: 'join',
        //   component: () => import('@/view/info/join.vue'),
        // },
        //  {
        //   path: '/payment',
        //   name: 'payment',
        //   component: () => import('@/view/pages/payment.vue'),
        // },
        {
          path: '/card-payments',
          name: 'card-payments',
          component: () => import('@/view/pages/card-payments.vue'),
        },
        {
          path: '/card-payouts',
          name: 'card-payouts',
          component: () => import('@/view/pages/card-payouts.vue'),
        },
        {
          path: '/travel-tourism',
          name: 'Travel & Tourism',
          component: () => import('@/view/info/travel-tourism.vue'),
        },
        {
          path: '/e-commerce',
          name: 'e-commerce',
          component: () => import('@/view/info/e-commerce.vue'),
        },
        {
          path: '/educational-platforms',
          name: 'educational-platforms',
          component: () => import('@/view/info/educational-platforms.vue'),
        },
        {
          path: '/online-gaming',
          name: 'online-gaming',
          component: () => import('@/view/info/online-gaming.vue'),
        },
        {
          path: '/marketplaces',
          name: 'marketplaces',
          component: () => import('@/view/info/marketplaces.vue'),
        },
        {
          path: '/e-saas',
          name: 'e-saas',
          component: () => import('@/view/info/e-saas.vue'),
        },
        {
          path: '/retail',
          name: 'retail',
          component: () => import('@/view/info/retail.vue'),
        },

        {
          path: '/cookiespolicy',
          name: 'cookiespolicy',
          component: () => import('@/view/info/cookiespolicy.vue'),
        },
        
      ]
    },
    
   
   
  ]
})

